import React, {InputHTMLAttributes} from 'react';
import {InputStyled, Label} from './styled';
import MaskedInput, {maskArray} from 'react-text-mask';
import Alert from '@material-ui/lab/Alert';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string,
    error: string,
    autocomplete?: string,
    mask?: maskArray,
    guide?: boolean,
    showError?: boolean,
    pipe?: (conformedValue: string, config: any) => false | string | { value: string, indexesOfPipedChars: number[] }
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            marginBottom: 10,
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(2),
            },
        },
    }),
);

const Input: React.FC<Props> = ({
                                    id,
                                    name,
                                    label,
                                    disabled,
                                    placeholder,
                                    required,
                                    value,
                                    type,
                                    autoComplete,
                                    error,
                                    mask,
                                    accept,
                                    autoFocus,
                                    guide = false,
                                    maxLength,
                                    showError = true,
                                    pipe,
                                    onChange,
                                    onBlur,
                                    min,
                                    max,
                                    step,
                                    style
                                }) => {
    const classes = useStyles();

    return (
        <div style={style}>
            {label && <Label htmlFor={id}>{label}</Label>}
            {mask &&
            <MaskedInput
                mask={mask}
                id={id}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                value={value}
                autoFocus={autoFocus}
                type={type}
                autoComplete={autoComplete}
                onBlur={onBlur}
                guide={guide}
                pipe={pipe}
                accept={accept}
                disabled={disabled}
                min={min}
                max={max}
                step={step}
                render={(ref, props) => (
                    <>
                        <InputStyled
                            ref={ref}
                            {...props}
                        />
                        {error &&
                            <div className={classes.root}>
                                <Alert severity="error">{error}</Alert>
                            </div>
                        }
                    </>
                )}
            />
            }

            {!mask &&
            <>
                <InputStyled
                    id={id}
                    name={name}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    value={value}
                    autoFocus={autoFocus}
                    type={type}
                    autoComplete={autoComplete}
                    onBlur={onBlur}
                    accept={accept}
                    disabled={disabled}
                    maxLength={maxLength}
                    min={min}
                    max={max}
                    step={step}
                />
                {(error && showError) &&
                <div className={classes.root}>
                    <Alert severity="error">{error}</Alert>
                </div>
                }
            </>
            }
        </div>
    )
}

export default Input;